import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3cb2c22e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")

  return (_openBlock(), _createBlock(_component_SvgWrapper, { class: "grid-lines" }, {
    default: _withId(() => [
      _createVNode("path", {
        style: {
        transform: `scale(${_ctx.canvasScale})`,
      },
        d: _ctx.path,
        fill: "none",
        stroke: _ctx.gridColor,
        "stroke-width": "0.3",
        "stroke-dasharray": "5"
      }, null, 12, ["d", "stroke"])
    ]),
    _: 1
  }))
})